import * as topojson from "topojson-client"
import topology from "./world.json"

const world = topojson.feature(topology, topology.objects.countries1)
const countries = world.features.map((feature) => {
  const { properties } = feature
  return {
    name: properties.name,
    code: properties["Alpha-2"],
  }
})

export { world, countries }
